module.exports = __webpack_public_path__ + "img/1920_banner_3.18b689b8.jpg";